/**
 * avatars/items/hat.js
 * Xây dựng hình học 3D cho createHat
 */

import * as THREE from 'three';
import { addChinStrap } from './shared.js';

export function createHat(lib, type, headSize) {
  const hatGroup = new THREE.Group();
  hatGroup.name = `Hat_${type}`;

  if (type === 'non_la' || type === 'non_la_tron') {
    // NÓN LÁ TRÒN DỐC THOẢI TRUYỀN THỐNG VIỆT NAM (Smooth Cone Nón Bài Thơ Xứ Huế)
    const strawMat = new THREE.MeshStandardMaterial({ color: '#fef3c7', roughness: 0.85 });
    const rimMat = new THREE.MeshStandardMaterial({ color: '#fde68a', roughness: 0.7 });
    const ribbonMat = new THREE.MeshStandardMaterial({ color: '#fb7185', roughness: 0.65 });
    lib.disposables.push(strawMat, rimMat, ribbonMat);

    // Thân nón hình nón tròn mềm mại dốc thoải
    const coneGeo = new THREE.ConeGeometry(headSize * 0.95, headSize * 0.6, 32);
    const cone = new THREE.Mesh(coneGeo, strawMat);
    cone.position.y = headSize * 1.15;
    cone.castShadow = true;
    hatGroup.add(cone);

    // Vành nón tròn uốn nan tre
    const rimGeo = new THREE.TorusGeometry(headSize * 0.94, 0.015, 8, 32);
    const rim = new THREE.Mesh(rimGeo, rimMat);
    rim.rotation.x = Math.PI / 2;
    rim.position.y = headSize * 0.85;
    hatGroup.add(rim);

    // 3 Vòng chỉ nan nón lá trang trí
    [0.95, 1.1, 1.25].forEach((yPos) => {
      const ringGeo = new THREE.TorusGeometry(headSize * 0.94 * (1 - (yPos - 0.85) / 0.6), 0.008, 6, 24);
      const ring = new THREE.Mesh(ringGeo, rimMat);
      ring.rotation.x = Math.PI / 2;
      ring.position.y = yPos * headSize * 0.95;
      hatGroup.add(ring);
      lib.disposables.push(ringGeo);
    });

    // Quai lụa hồng chạy từ vành nón dọc hai má, thắt dưới cằm
    addChinStrap(lib, hatGroup, headSize, headSize * 0.85, ribbonMat);

    lib.disposables.push(coneGeo, rimGeo);
  } else if (type === 'mu_coi') {
    // MŨ CỐI BỘ ĐỘI VIỆT NAM CHUẨN VOXEL (Loại bỏ Cylinder trơn nhẵn!)
    const armyGreenMat = new THREE.MeshStandardMaterial({
      color: '#2e4a2e', // Xanh rêu quân đội
      roughness: 0.75
    });
    const starYellowMat = new THREE.MeshBasicMaterial({ color: '#facc15' }); // Sao vàng phát sáng
    const badgeRedMat = new THREE.MeshStandardMaterial({ color: '#dc2626', roughness: 0.5 });
    lib.disposables.push(armyGreenMat, starYellowMat, badgeRedMat);

    // Thân mũ cối phân tầng vát
    const crownBaseGeo = new THREE.BoxGeometry(headSize * 1.12, headSize * 0.32, headSize * 1.18);
    const crownBase = new THREE.Mesh(crownBaseGeo, armyGreenMat);
    crownBase.position.set(0, headSize * 1.02, headSize * 0.02);
    crownBase.castShadow = true;
    hatGroup.add(crownBase);

    const crownTopGeo = new THREE.BoxGeometry(headSize * 0.9, headSize * 0.12, headSize * 0.95);
    const crownTop = new THREE.Mesh(crownTopGeo, armyGreenMat);
    crownTop.position.set(0, headSize * 1.2, headSize * 0.02);
    crownTop.castShadow = true;
    hatGroup.add(crownTop);

    // Vành mũ cối: vành sau rộng che gáy, vành trước ngắn
    const brimGeo = new THREE.BoxGeometry(headSize * 1.34, 0.035, headSize * 1.48);
    const brim = new THREE.Mesh(brimGeo, armyGreenMat);
    brim.position.set(0, headSize * 0.88, -headSize * 0.04);
    brim.castShadow = true;
    hatGroup.add(brim);

    // Huy hiệu tròn đỏ và ngôi sao vàng 5 cánh nổi khối 3D chính giữa trán
    const badgeGeo = new THREE.BoxGeometry(headSize * 0.22, headSize * 0.22, 0.02);
    const badge = new THREE.Mesh(badgeGeo, badgeRedMat);
    badge.position.set(0, headSize * 1.04, headSize * 0.6);
    hatGroup.add(badge);

    const starHGeo = new THREE.BoxGeometry(headSize * 0.15, 0.035, 0.025);
    const starH = new THREE.Mesh(starHGeo, starYellowMat);
    starH.position.set(0, headSize * 1.04, headSize * 0.615);
    hatGroup.add(starH);

    const starVGeo = new THREE.BoxGeometry(0.035, headSize * 0.15, 0.025);
    const starV = new THREE.Mesh(starVGeo, starYellowMat);
    starV.position.set(0, headSize * 1.04, headSize * 0.615);
    hatGroup.add(starV);

    lib.disposables.push(crownBaseGeo, crownTopGeo, brimGeo, badgeGeo, starHGeo, starVGeo);
  } else if (type === 'mu_bh_grab') {
    // MŨ CỐI GRAB VIỆT NAM VOXEL (Dáng mũ cối phân tầng vát, vành rộng che gáy, sọc trắng Grab & quai cằm thực tế)
    const grabGreenMat = new THREE.MeshStandardMaterial({ color: '#00b14f', roughness: 0.5 });
    const whiteMat = new THREE.MeshStandardMaterial({ color: '#f8fafc', roughness: 0.5 });
    const blackStrapMat = new THREE.MeshStandardMaterial({ color: '#18181b', roughness: 0.7 });
    lib.disposables.push(grabGreenMat, whiteMat, blackStrapMat);

    // 1. Thân mũ cối phân tầng vát màu xanh Grab
    const crownBaseGeo = new THREE.BoxGeometry(headSize * 1.12, headSize * 0.32, headSize * 1.18);
    const crownBase = new THREE.Mesh(crownBaseGeo, grabGreenMat);
    crownBase.position.set(0, headSize * 1.02, headSize * 0.02);
    crownBase.castShadow = true;
    hatGroup.add(crownBase);

    const crownTopGeo = new THREE.BoxGeometry(headSize * 0.9, headSize * 0.12, headSize * 0.95);
    const crownTop = new THREE.Mesh(crownTopGeo, grabGreenMat);
    crownTop.position.set(0, headSize * 1.2, headSize * 0.02);
    crownTop.castShadow = true;
    hatGroup.add(crownTop);

    // 2. Vành mũ cối đặc trưng: vành sau rộng che gáy, vành trước ngắn gọn
    const brimGeo = new THREE.BoxGeometry(headSize * 1.34, 0.035, headSize * 1.48);
    const brim = new THREE.Mesh(brimGeo, grabGreenMat);
    brim.position.set(0, headSize * 0.88, -headSize * 0.04);
    brim.castShadow = true;
    hatGroup.add(brim);

    // 3. Dải sọc trắng phản quang Grab chạy ngang thân mũ cối
    const stripeGeo = new THREE.BoxGeometry(headSize * 1.13, 0.06, headSize * 1.19);
    const stripe = new THREE.Mesh(stripeGeo, whiteMat);
    stripe.position.set(0, headSize * 1.0, headSize * 0.02);
    hatGroup.add(stripe);

    // 4. Quai cằm ôm sát má & khóa cài bên phải
    addChinStrap(lib, hatGroup, headSize, headSize * 0.86, blackStrapMat, true);

    lib.disposables.push(crownBaseGeo, crownTopGeo, brimGeo, stripeGeo);
  } else if (type === 'mu_bh_shopee') {
    // MŨ BẢO HIỂM SHIPPER / SHOPEE NỬA ĐẦU VOXEL (Màu cam rực rỡ, sọc trắng phản quang)
    const shopeeOrangeMat = new THREE.MeshStandardMaterial({ color: '#ea580c', roughness: 0.5 });
    const whiteMat = new THREE.MeshStandardMaterial({ color: '#f8fafc', roughness: 0.5 });
    const blackStrapMat = new THREE.MeshStandardMaterial({ color: '#18181b', roughness: 0.7 });
    lib.disposables.push(shopeeOrangeMat, whiteMat, blackStrapMat);

    const helmetGeo = new THREE.BoxGeometry(headSize * 1.14, headSize * 0.34, headSize * 1.18);
    const helmet = new THREE.Mesh(helmetGeo, shopeeOrangeMat);
    helmet.position.set(0, headSize * 0.96, 0);
    helmet.castShadow = true;
    hatGroup.add(helmet);

    const stripeGeo = new THREE.BoxGeometry(headSize * 1.15, 0.06, headSize * 1.19);
    const stripe = new THREE.Mesh(stripeGeo, whiteMat);
    stripe.position.set(0, headSize * 0.96, 0);
    hatGroup.add(stripe);

    const tier1Geo = new THREE.BoxGeometry(headSize * 0.96, headSize * 0.12, headSize * 1.02);
    const tier1 = new THREE.Mesh(tier1Geo, shopeeOrangeMat);
    tier1.position.set(0, headSize * 1.14, 0);
    tier1.castShadow = true;
    hatGroup.add(tier1);

    const tier2Geo = new THREE.BoxGeometry(headSize * 0.72, headSize * 0.06, headSize * 0.78);
    const tier2 = new THREE.Mesh(tier2Geo, shopeeOrangeMat);
    tier2.position.set(0, headSize * 1.21, 0);
    tier2.castShadow = true;
    hatGroup.add(tier2);

    const visorBrimGeo = new THREE.BoxGeometry(headSize * 0.95, 0.035, 0.14);
    const visorBrim = new THREE.Mesh(visorBrimGeo, shopeeOrangeMat);
    visorBrim.position.set(0, headSize * 0.81, headSize * 0.6);
    visorBrim.rotation.x = 0.14;
    hatGroup.add(visorBrim);

    addChinStrap(lib, hatGroup, headSize, headSize * 0.8, blackStrapMat, true);

    lib.disposables.push(helmetGeo, stripeGeo, tier1Geo, tier2Geo, visorBrimGeo);
  } else if (type === 'mu_bao_ve') {
    // MŨ MỀM BẢO VỆ CHUNG CƯ / TÒA NHÀ VOXEL (Màu xanh thẫm, lưỡi trai đen, huy hiệu vàng)
    const navyMat = new THREE.MeshStandardMaterial({ color: '#0f172a', roughness: 0.7 });
    const visorMat = new THREE.MeshStandardMaterial({ color: '#09090b', roughness: 0.3 });
    const goldMat = new THREE.MeshStandardMaterial({ color: '#f59e0b', metalness: 0.85, roughness: 0.2 });
    const redBadgeMat = new THREE.MeshStandardMaterial({ color: '#dc2626', roughness: 0.5 });
    lib.disposables.push(navyMat, visorMat, goldMat, redBadgeMat);

    // Thân mũ hình hộp dẹt mở rộng
    const capGeo = new THREE.BoxGeometry(headSize * 1.08, headSize * 0.26, headSize * 1.12);
    const cap = new THREE.Mesh(capGeo, navyMat);
    cap.position.set(0, headSize * 1.02, -headSize * 0.02);
    cap.castShadow = true;
    hatGroup.add(cap);

    // Vành lưỡi trai đen bóng phía trước
    const visorGeo = new THREE.BoxGeometry(headSize * 0.92, 0.03, headSize * 0.36);
    const visor = new THREE.Mesh(visorGeo, visorMat);
    visor.position.set(0, headSize * 0.92, headSize * 0.62);
    visor.rotation.x = 0.18;
    visor.castShadow = true;
    hatGroup.add(visor);

    // Dây viền mạ vàng trên vành lưỡi trai
    const strapGeo = new THREE.BoxGeometry(headSize * 0.88, 0.02, 0.02);
    const strap = new THREE.Mesh(strapGeo, goldMat);
    strap.position.set(0, headSize * 0.96, headSize * 0.56);
    hatGroup.add(strap);

    // Huy hiệu tròn nền đỏ sao vàng phía trước mũ
    const badgeGeo = new THREE.BoxGeometry(0.08, 0.08, 0.02);
    const badge = new THREE.Mesh(badgeGeo, redBadgeMat);
    badge.position.set(0, headSize * 1.08, headSize * 0.55);
    hatGroup.add(badge);

    const starGeo = new THREE.BoxGeometry(0.045, 0.045, 0.022);
    const star = new THREE.Mesh(starGeo, goldMat);
    star.position.set(0, headSize * 1.08, headSize * 0.555);
    star.rotation.z = Math.PI / 4;
    hatGroup.add(star);

    lib.disposables.push(capGeo, visorGeo, strapGeo, badgeGeo, starGeo);
  } else if (type === 'mu_cao_boi') {
    // Mũ cao bồi da bò Voxel
    const leatherMat = new THREE.MeshStandardMaterial({ color: '#78350f', roughness: 0.8 });
    const crownGeo = new THREE.BoxGeometry(headSize * 0.85, headSize * 0.42, headSize * 1.05);
    const crown = new THREE.Mesh(crownGeo, leatherMat);
    crown.position.set(0, headSize * 1.1, 0);
    crown.castShadow = true;
    hatGroup.add(crown);

    // Vành mũ rộng uốn cong hai bên
    const brimCenterGeo = new THREE.BoxGeometry(headSize * 0.9, 0.035, headSize * 1.55);
    const brimCenter = new THREE.Mesh(brimCenterGeo, leatherMat);
    brimCenter.position.set(0, headSize * 0.9, 0);
    hatGroup.add(brimCenter);

    [-1, 1].forEach((side) => {
      const brimSideGeo = new THREE.BoxGeometry(headSize * 0.32, 0.035, headSize * 1.55);
      const brimSide = new THREE.Mesh(brimSideGeo, leatherMat);
      brimSide.position.set(side * (headSize * 0.55), headSize * 0.94, 0);
      brimSide.rotation.z = -side * 0.22; // Vành uốn cong lên
      hatGroup.add(brimSide);
      lib.disposables.push(brimSideGeo);
    });

    lib.disposables.push(leatherMat, crownGeo, brimCenterGeo);
  } else if (type === 'mu_luoi_trai') {
    // Mũ lưỡi trai thể thao Voxel
    const capMat = new THREE.MeshStandardMaterial({ color: '#2563eb', roughness: 0.6 });
    const capGeo = new THREE.BoxGeometry(headSize * 1.08, headSize * 0.28, headSize * 1.1);
    const cap = new THREE.Mesh(capGeo, capMat);
    cap.position.set(0, headSize * 0.98, 0);
    cap.castShadow = true;
    hatGroup.add(cap);

    const visorGeo = new THREE.BoxGeometry(headSize * 0.96, 0.035, headSize * 0.52);
    const visor = new THREE.Mesh(visorGeo, capMat);
    visor.position.set(0, headSize * 0.88, headSize * 0.68);
    hatGroup.add(visor);

    lib.disposables.push(capMat, capGeo, visorGeo);
  } else if (type === 'foster_mushroom') {
    // MŨ NẤM DẠ QUANG PHÁT SÁNG (Bioluminescent Mushroom Cap)
    const capMat = new THREE.MeshStandardMaterial({ color: '#059669', roughness: 0.6 });
    const spotMat = new THREE.MeshBasicMaterial({ color: '#6ee7b7' });
    lib.disposables.push(capMat, spotMat);

    // Tán nấm chính rộng bao quanh đầu
    const mushGeo = new THREE.BoxGeometry(headSize * 1.5, headSize * 0.45, headSize * 1.5);
    const mush = new THREE.Mesh(mushGeo, capMat);
    mush.position.set(0, headSize * 1.15, 0);
    mush.castShadow = true;
    hatGroup.add(mush);

    // Đỉnh chóp nấm
    const topGeo = new THREE.BoxGeometry(headSize * 1.1, headSize * 0.35, headSize * 1.1);
    const top = new THREE.Mesh(topGeo, capMat);
    top.position.set(0, headSize * 1.45, 0);
    hatGroup.add(top);

    // 4 Đốm bào tử dạ quang phát sáng
    [-0.45, 0.45].forEach((dx) => {
      [-0.45, 0.45].forEach((dz) => {
        const sGeo = new THREE.BoxGeometry(headSize * 0.22, 0.04, headSize * 0.22);
        const s = new THREE.Mesh(sGeo, spotMat);
        s.position.set(dx * headSize, headSize * 1.38, dz * headSize);
        hatGroup.add(s);
        lib.disposables.push(sGeo);
      });
    });

    lib.disposables.push(mushGeo, topGeo);
  } else if (type === 'astronaut_helm') {
    // MŨ PHI HÀNH GIA LƯỢNG TỬ (Quantum Astronaut Helmet)
    const helmMat = new THREE.MeshStandardMaterial({ color: '#f8fafc', roughness: 0.3, metalness: 0.5 });
    const visorGlassMat = new THREE.MeshPhysicalMaterial({
      color: '#38bdf8',
      metalness: 0.9,
      roughness: 0.1,
      transparent: true,
      opacity: 0.85
    });
    lib.disposables.push(helmMat, visorGlassMat);

    // Vỏ mũ bao quanh đầu
    const domeGeo = new THREE.BoxGeometry(headSize * 1.25, headSize * 1.25, headSize * 1.25);
    const dome = new THREE.Mesh(domeGeo, helmMat);
    dome.position.set(0, headSize * 0.55, 0);
    hatGroup.add(dome);

    // Kính holographic cong phía trước
    const vGeo = new THREE.BoxGeometry(headSize * 1.05, headSize * 0.65, 0.08);
    const v = new THREE.Mesh(vGeo, visorGlassMat);
    v.position.set(0, headSize * 0.55, headSize * 0.62);
    hatGroup.add(v);

    lib.disposables.push(domeGeo, vGeo);
  } else if (type === 'bone_mask') {
    // MẶT NẠ SỌ XƯƠNG NGOÀI HÀNH TINH (Ancient Alien Skull)
    const boneMat = new THREE.MeshStandardMaterial({ color: '#e7e5e4', roughness: 0.7 });
    const toothMat = new THREE.MeshStandardMaterial({ color: '#fafaf9', roughness: 0.3 });
    lib.disposables.push(boneMat, toothMat);

    // Mặt nạ sọ trước mặt
    const mGeo = new THREE.BoxGeometry(headSize * 1.05, headSize * 0.85, 0.08);
    const m = new THREE.Mesh(mGeo, boneMat);
    m.position.set(0, headSize * 0.55, headSize * 0.54);
    hatGroup.add(m);

    // 2 Hốc mắt rỗng
    const eyeHoleMat = new THREE.MeshBasicMaterial({ color: '#09090b' });
    lib.disposables.push(eyeHoleMat);
    [-1, 1].forEach((side) => {
      const hGeo = new THREE.BoxGeometry(headSize * 0.25, headSize * 0.22, 0.09);
      const h = new THREE.Mesh(hGeo, eyeHoleMat);
      h.position.set(side * headSize * 0.24, headSize * 0.6, headSize * 0.55);
      hatGroup.add(h);
      lib.disposables.push(hGeo);
    });

    // 4 Răng nanh xương nhọn chìa xuống
    [-0.25, -0.08, 0.08, 0.25].forEach((tx) => {
      const tGeo = new THREE.BoxGeometry(0.04, 0.08, 0.04);
      const t = new THREE.Mesh(tGeo, toothMat);
      t.position.set(tx * headSize, headSize * 0.12, headSize * 0.55);
      hatGroup.add(t);
      lib.disposables.push(tGeo);
    });

    lib.disposables.push(mGeo);
  } else if (type === 'gas_mask_helm') {
    // MŨ LỌC ĐỘC 2 VAN KHÍ QUYỂN (Bio-Hazard Respirator Helmet)
    const hoodMat = new THREE.MeshStandardMaterial({ color: '#3f6212', roughness: 0.7 });
    const filterMat = new THREE.MeshStandardMaterial({ color: '#1c1917', metalness: 0.7, roughness: 0.3 });
    const eyeMat = new THREE.MeshStandardMaterial({ color: '#facc15', metalness: 0.8, roughness: 0.2 });
    lib.disposables.push(hoodMat, filterMat, eyeMat);

    // Mũ trùm đầu kín
    const hoodGeo = new THREE.BoxGeometry(headSize * 1.15, headSize * 1.15, headSize * 1.15);
    const hood = new THREE.Mesh(hoodGeo, hoodMat);
    hood.position.set(0, headSize * 0.55, 0);
    hatGroup.add(hood);

    // 2 Tròng kính tròn lọc khí vàng
    [-1, 1].forEach((side) => {
      const gGeo = new THREE.CylinderGeometry(headSize * 0.15, headSize * 0.15, 0.04, 16);
      gGeo.rotateX(Math.PI / 2);
      const g = new THREE.Mesh(gGeo, eyeMat);
      g.position.set(side * headSize * 0.25, headSize * 0.6, headSize * 0.58);
      hatGroup.add(g);
      lib.disposables.push(gGeo);
    });

    // 2 Hộp van lọc thở bên má
    [-1, 1].forEach((side) => {
      const canGeo = new THREE.CylinderGeometry(headSize * 0.14, headSize * 0.14, 0.12, 12);
      canGeo.rotateZ(side * 0.3);
      const can = new THREE.Mesh(canGeo, filterMat);
      can.position.set(side * headSize * 0.42, headSize * 0.22, headSize * 0.48);
      hatGroup.add(can);
      lib.disposables.push(canGeo);
    });

    lib.disposables.push(hoodGeo);
  } else if (type === 'crown_gold') {
    // VƯƠNG MIỆN HOÀNG KIM NẠM NGỌC (Midas Crown)
    const goldMat = new THREE.MeshStandardMaterial({ color: '#f59e0b', metalness: 0.95, roughness: 0.15 });
    const gemMat = new THREE.MeshStandardMaterial({ color: '#10b981', roughness: 0.1, metalness: 0.8 });
    lib.disposables.push(goldMat, gemMat);

    // Vành vương miện
    const bandGeo = new THREE.BoxGeometry(headSize * 1.08, headSize * 0.12, headSize * 1.08);
    const band = new THREE.Mesh(bandGeo, goldMat);
    band.position.set(0, headSize * 1.02, 0);
    hatGroup.add(band);

    // 5 Đỉnh chóp nhọn
    for (let i = -2; i <= 2; i++) {
      const h = Math.abs(i) === 0 ? 0.28 : Math.abs(i) === 1 ? 0.22 : 0.16;
      const spikeGeo = new THREE.BoxGeometry(0.06, headSize * h, 0.04);
      const spike = new THREE.Mesh(spikeGeo, goldMat);
      spike.position.set(i * headSize * 0.22, headSize * 1.08 + (headSize * h) / 2, headSize * 0.54);
      hatGroup.add(spike);

      // Viên ngọc đính trên đỉnh
      const gGeo = new THREE.BoxGeometry(0.04, 0.04, 0.04);
      const g = new THREE.Mesh(gGeo, gemMat);
      g.position.set(i * headSize * 0.22, headSize * 1.08 + headSize * h, headSize * 0.55);
      hatGroup.add(g);
      lib.disposables.push(spikeGeo, gGeo);
    }

    lib.disposables.push(bandGeo);
  }

  return hatGroup;
}
